import { GraduationCap, Award, Users, Sparkles, BookOpen, Star, Trophy, Heart } from "lucide-react";

// Icon keys stored in the DB -> lucide component. Keep keys stable.
export const CREDENTIAL_ICONS = {
  "graduation-cap": GraduationCap,
  award: Award,
  users: Users,
  sparkles: Sparkles,
  "book-open": BookOpen,
  star: Star,
  trophy: Trophy,
  heart: Heart,
};

export const CREDENTIAL_ICON_OPTIONS = [
  { key: "graduation-cap", label: "Graduation cap" },
  { key: "award", label: "Award" },
  { key: "users", label: "People" },
  { key: "sparkles", label: "Sparkles" },
  { key: "book-open", label: "Book" },
  { key: "star", label: "Star" },
  { key: "trophy", label: "Trophy" },
  { key: "heart", label: "Heart" },
];

export const DEFAULT_CREDENTIAL_ICON = "graduation-cap";

export function credentialIcon(key) {
  return CREDENTIAL_ICONS[key] || GraduationCap;
}
